import { FAIcon } from '../../Icons/Icons';
import { SelectorType, TabDesign } from '../types/enums';
import { TabiconProps, TabiconTheme } from './type/proptype';
import styles from './TabIcon.module.scss';

const getTabDesignClass = (design: TabDesign) => {
  switch (design) {
    case TabDesign.SOLID:
      return 'solid';
    case TabDesign.ICON_CIRCLE:
      return 'icon-circle';
    default:
      return '';
  }
};

const Tabicon = ({
  theme,
  selected = false,
  icon,
  iconStyle,
  design,
  disabled = false,
  selectorType = SelectorType.UNDERLINE,
  iconClass,
}: TabiconProps) => {
  const disabledClass = disabled ? styles['disabled'] : '';

  return (
    <>
      {icon &&
        (selectorType === SelectorType.UNDERLINE ? (
          <FAIcon theme={theme} iconName={icon} iconStyle={iconStyle} className={`${styles['icon']} ${iconClass}`} />
        ) : (
          <div
            className={`${styles['tab-icon-container']} ${styles[getTabDesignClass(design)]} ${
              selected ? styles['selected'] : ''
            } ${theme && selected ? styles[theme] : ''} ${disabledClass}`}
          >
            <div
              className={`${styles['icon-container']} ${styles[getTabDesignClass(design)]} ${
                theme ? styles[theme] : ''
              } ${selected && !disabled ? styles['selected-icon'] : ''} ${disabledClass}`}
            >
              <span className={styles['simple-icon']}>
                <FAIcon
                  theme={theme}
                  iconName={icon}
                  iconStyle={iconStyle}
                  className={`${styles['icon']} ${iconClass} ${disabledClass}`}
                />
              </span>
            </div>
          </div>
        ))}
    </>
  );
};
export default Tabicon;
export type { TabiconTheme };
